export const Days = ({ days }) => {
  // `days` is some combination of mo,tu,we,th,fr,sa,su
  const displayDays = days.split(",").join(", ")
  return <div className="capitalize mb-0">{displayDays}</div>
}
